//エラー画面
export const ERROR = "/error";
//タイムアウト画面
export const TIMEOUT = "/timeout";

//マイページ
export const MY_PAGE = "/my-page";

//新規利用者判定画面
export const IS_NEW_CUSTOMER_HANDLER = "/is-new-customer-handler";
//利用者情報登録結果画面
export const CUSTOMER_PRE_INFO = "/customer-pre-info";
//利用者情報登録（本人）画面
export const CUSTOMER_CREATOR = "/customer-creator";
//利用者情報登録結果（本人）画面
export const CUSTOMER_RESULT = "/customer-result";
//利用者情報変更画面
export const CUSTOMER_UPDATER = "/customer-updater";
//利用者家族情報登録
export const FAMILY_ADDER = "/family-adder";

//問診利用者選択
export const MEDICAL_QUESTIONNAIRES_CUSTOMER_SELECTOR =
  "/medical-questionnaires-customer-selector";
//問診
export const MEDICAL_QUESTIONNAIRES = "/medical-questionnaires";
//利用者選択
export const IS_NEW_PHARMACY_SELECTOR = "/is-new-pharmacy-selector";

//お会計
export const MEDICAL_ACCOUNT = "/medical-account";
//お会計  [クレジットカード決済]
export const SELECT_CREDIT_CARD = "/select-credit-card";
//決済中
export const PAYING_PAGE = "/paying-page";
//PAY決済開始
export const START_PAY = "/start-pay";
//GMO I/F呼出
export const NAVIGATE_PAY = "/navigate-pay";
//PAY決済確認中
export const CONFIRMING_PAY = "/confirming-pay";
//利用履歴
export const PRESCRIPTION_HISTORY = "/prescription-history";
//受取薬履歴
export const MEDICAL_HISTORY = "/medical-history";
//受取薬明細
export const RECEIVE_MEDICATION_DETAILS = "/receive-medication-details";

//薬局一覧
export const PHARMACY_LIST = "/pharmacy-list";
//薬局選択
export const PHARMACY_SELECTOR = "/pharmacy-selector";
//薬局情報
export const PHARMACY_INFORMATION = "/pharmacy-information";
//処方箋種類選択
export const PRESCRIPTION_TYPE_SELECTOR = "/prescription-type-selector";
//問診未回答
export const INTERVIEW_NOT_REGISTERED = "/interview-not-registered";

//処方箋申込[服薬指導]
export const PRESCRIPTION_DIRECTOR = "/prescription-director";
//処方箋申込[服薬指導予約]
export const PRESCRIPTION_RESERVATION = "/prescription-reservation";
//処方箋申込[受取方法]
export const RECEPTION_METHOD = "/reception-method";
//処方箋申込[保険証]
export const INSURANCE_INFORMATION = "/insurance-information";
//処方箋申込[処方箋]
export const PRESCRIPTION_CREATOR = "/prescription-creator";
//処方箋申込[完了]
export const FINISHED_PRESCRIPTION = "/finished-prescription";
//処方箋申込[特定商取引法に基づく表記]
export const SPECIFIED_COMMERCIAL = "/specifiedCommercial";
//処方箋申込[利用者選択]
export const CUSTOMER_SELECTOR = "/customer-selector";

// skywayオンライン面談
export const PRESCRIPTION_MEDICATION_GUIDANCE =
  "/prescriptionMedicationGuidance";
// 物品譲渡用決済方法選択画面
export const PRODUCT_DELIVERY_SELECT_PAYMENT_METHOD =
  "/product-delivery/select-payment-method";
// 物品譲渡用決済画面
export const PRODUCT_DELIVERY_SELECT_CREDIT_CARD =
  "/product-delivery/select-credit-card";
// 物品譲渡用決済完了
export const PRODUCT_DELIVERY_COMPLETE_PAYMENT =
  "/product-delivery/complete-payment";
// 物品譲渡用エラー画面
export const PRODUCT_DELIVERY_ERROR = "/product-delivery/error";
// 物品譲渡用Pay決済開始画面
export const PRODUCT_DELIVERY_START_PAY = "/product-delivery/start-pay";
// 物品譲渡用PAY決済確認中
export const PRODUCT_DELIVERY_CONFIRMING_PAY =
  "/product-delivery/confirming-pay";
